import { useContext, useState } from 'react';
import { useAsyncEffect } from '../../../hooks/UseAsyncEffect';
import { TransactionResult } from '../../../sdk/SearchServiceClient';
import { toCurrency, toFormattedDate } from '../../../utilities/FormatHelpers';
import { AccountContext } from '../AccountContext';

export default function OtherTransactions() {
  const { accountId, searchService, setError } = useContext(AccountContext);
  const [transactions, setTransactions] = useState<TransactionResult[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [refresh, setRefresh] = useState(0);

  useAsyncEffect(async () => {
    try {
      setLoading(true);
      setLoadError(null);
      setTransactions(await searchService.getOtherTransactions(accountId));
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      setLoadError(message);
      setTransactions([]);
      setError({ source: 'Get Other Transactions', message });
    } finally {
      setLoading(false);
    }
  }, [accountId, refresh]);

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2>Other Transactions</h2>
        <button className="ui small button" type="button" disabled={loading} onClick={() => setRefresh((value) => value + 1)}>
          Refresh
        </button>
      </div>
      {loading && <div className="ui active centered inline loader" />}
      {!loading && loadError && <p role="alert">Could not load transactions: {loadError}</p>}
      {!loading && !loadError && transactions.length === 0 && <p>No Other Transactions</p>}
      {!loading && !loadError && transactions.length > 0 && (
        <div className="scrollable">
          <table className="ui single line table">
            <thead>
              <tr>
                <th>Transaction</th>
                <th>Amount</th>
                <th>Effective Date</th>
                <th>Posting Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((transaction) => (
                <tr key={transaction.transactionId}>
                  <td>
                    {transaction.balanceMovementType} {transaction.description != null ? `(${transaction.description})` : ''}
                    <div className="ui grey sub header">{transaction.transactionId}</div>
                  </td>
                  <td>{toCurrency(transaction.amount.value)}</td>
                  <td>{toFormattedDate(transaction.effectiveDate, 'yyyy-MM-dd HH:mm:ss')}</td>
                  <td>{toFormattedDate(transaction.postingDate, 'yyyy-MM-dd HH:mm:ss')}</td>
                  <td>{transaction.transactionStatus}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
